function ensureOnScreen(el) {
  const rect = el.getBoundingClientRect();
  const occluded =
    rect.left < 0 ||
    rect.top < 0 ||
    rect.right > window.innerWidth ||
    rect.bottom > window.innerHeight;

  if (occluded) {
    el.style.top = `${Math.max(0, rect.top)}px`;
    el.style.left = `${Math.max(0, rect.left)}px`;
  }
}

/**
 * Make a fixed-position element draggable via a handle (or the whole element).
 * Returns a cleanup function.
 */
export function makeDraggable(el, options = {}) {
  const {
    handleSelector = null,
    storageKeyPrefix = null,
    onPositionChange = null,
  } = options;

  if (!el || !(el instanceof HTMLElement)) return () => {};

  if (storageKeyPrefix) {
    const top = localStorage.getItem(`${storageKeyPrefix}Top`);
    const left = localStorage.getItem(`${storageKeyPrefix}Left`);
    if (top && left) {
      el.style.top = top;
      el.style.left = left;
    }
  }

  ensureOnScreen(el);
  if (typeof onPositionChange === 'function') {
    onPositionChange(el);
  }

  let pos1 = 0;
  let pos2 = 0;
  let pos3 = 0;
  let pos4 = 0;

  const dragElement =
    (handleSelector && el.querySelector(handleSelector)) || el;

  function elementDrag(e) {
    e.preventDefault();
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    el.style.top = `${el.offsetTop - pos2}px`;
    el.style.left = `${el.offsetLeft - pos1}px`;
    if (typeof onPositionChange === 'function') {
      onPositionChange(el);
    }
  }

  function closeDragElement() {
    document.removeEventListener('mouseup', closeDragElement);
    document.removeEventListener('mousemove', elementDrag);
    ensureOnScreen(el);
    if (typeof onPositionChange === 'function') {
      onPositionChange(el);
    }
    if (storageKeyPrefix) {
      localStorage.setItem(`${storageKeyPrefix}Top`, el.style.top);
      localStorage.setItem(`${storageKeyPrefix}Left`, el.style.left);
    }
  }

  function dragMouseDown(e) {
    if (e.button !== 0) return;
    if (e.target.closest('button, input, textarea, select, a')) return;
    e.preventDefault();
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.addEventListener('mouseup', closeDragElement);
    document.addEventListener('mousemove', elementDrag);
  }

  dragElement.addEventListener('mousedown', dragMouseDown);

  return () => {
    dragElement.removeEventListener('mousedown', dragMouseDown);
    document.removeEventListener('mouseup', closeDragElement);
    document.removeEventListener('mousemove', elementDrag);
  };
}